import React, { useState } from 'react';
import { Alert, Form, FormGroup } from "react-bootstrap";
import { Dropdown, Label } from "semantic-ui-react";
import {Trans, useTranslation} from "react-i18next";

const VolunteerApplicationEducation = (props) => {

  const {t, i18n} = useTranslation('volunteer-application');

  const [linesOfEducation, setLinesOfEducation] = useState(undefined);
  if (linesOfEducation === undefined) {
    let e = props.linesOfEducation.map(lineOfEducation => {
      return {
        key: lineOfEducation.lineOfEducationId,
        text: lineOfEducation.title[i18n.language],
        value: lineOfEducation.lineOfEducationId
      }
    });
    e.push({
      key: '00000000-0000-0000-0000-000000000000',
      text: 'Άλλο',
      value: '00000000-0000-0000-0000-000000000000'
    })
    setLinesOfEducation(e);
  }

  const translateError = (errorCode, values) => {
    if (errorCode !== undefined) {
      return t('volunteer-application.error.' + errorCode, values);
    } else {
      return '';
    }
  }

  const translateLineOfEducation = (lineOfEducationId) => {
    if (lineOfEducationId === '00000000-0000-0000-0000-000000000000') {
      return '';
    }

    return props.linesOfEducation.find(l => l.lineOfEducationId === lineOfEducationId).title[i18n.language];
  }

  const translateEducationLevel = (levelOfEducation) => {
    return t('volunteer-application.form.level-of-education-value.' + levelOfEducation);
  }

  return <div id="volunteer-application-approval-education">
    {
      props.values.lineOfEducationId === "00000000-0000-0000-0000-000000000000" &&
      <>
        <Alert variant="danger">
          <Alert.Heading>{t('volunteer-application.notes.no-line-of-education-selected.header')}</Alert.Heading>
          <p>{t('volunteer-application.notes.no-line-of-education-selected.description')}</p>
          <hr/>
          <p className={'mb-0'}>
            <Trans t={t} i18nKey={'volunteer-application.notes.no-line-of-education-selected.footnote'}
                   values={{'otherLineOfEducation': props.values.otherLineOfEducation}}>
              Ο τομέας σπουδών που δε βρέθηκε 2: <b>{props.values.otherLineOfEducation}</b>
            </Trans>
          </p>
        </Alert>
        <Form.Row>
          <FormGroup controlId="lineOfEducationId" className="col-sm mb-3">
            <Form.Label>{t('volunteer-application.form.line-of-education')}</Form.Label>
            <Dropdown
              placeholder={t('volunteer-application.form.line-of-education-placeholder')}
              fluid
              search
              error={translateError(props.errors.lineOfEducationId)}
              selection
              options={linesOfEducation}
              value={props.values.lineOfEducationId}
              onChange={(event, data) => props.setFieldValue('lineOfEducationId', data.value)}
            />
            {
              props.errors.lineOfEducationId &&
              <Label color='red' pointing>{translateError(props.errors.lineOfEducationId)}</Label>
            }
          </FormGroup>
        </Form.Row>
      </>
    }

    {
      props.values.lineOfEducationId !== "00000000-0000-0000-0000-000000000000" &&
      <div className={'row'}>
        <div className={'col mb-3'}>
          <div>{t('volunteer-application.form.line-of-education')}</div>
          <div><b>{translateLineOfEducation(props.values.lineOfEducationId)}</b></div>
        </div>
      </div>
    }

    <div className={'row'}>
      <div className={'col mb-3'}>
        <div>{t('volunteer-application.form.line-of-education')}</div>
        <div><b>{translateEducationLevel(props.values.educationLevel)}</b></div>
      </div>
    </div>

    <div className={'row'}>
      <div className={'col mb-3'}>
        <div>{t('volunteer-application.form.employer')}</div>
        <div><b>{props.values.employer}</b></div>
      </div>
    </div>
  </div>
}

export default VolunteerApplicationEducation;